<script lang="ts">
	import UniversesBanner from '$lib/components/universes/UniversesBanner.svelte';
</script>


<div class="universes">
    <UniversesBanner type="menu"/>
</div>


<style lang="scss">
  .universes {
    padding: 0 20px 30px;
    
    @media (max-width: 1024px) {
      overflow-y: scroll;
      height: calc(100dvh - 166px);
    }
  }
</style>